import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  icon: {
    width: theme.spacing(1.75),
    height: theme.spacing(1.75),
    fontSize: theme.spacing(1.75),
    padding: theme.spacing(0, 1.2, 0, 0),
  },
  text: {
    fontFamily: 'Poppins',
    fontSize: theme.spacing(1.75),
    fontWeight: 500,
    lineHeight: '20px',
    textAlign: 'center',
    textUnderlinePosition: 'from-font',
    textDecorationSkipInk: 'none',
    letterSpacing: '0.1px',
  },
  account: {
    fontFamily: 'Poppins',
    fontSize: theme.spacing(1.5),
    fontWeight: 400,
    lineHeight: '16px',
    textAlign: 'center',
  },
  copyIcon: {
    cursor: 'pointer',
    fontSize: theme.spacing(2.2),
    border: '1.5px solid #E2E2E2',
    borderRadius: '4px',
  },
  currency: {
    color: theme.palette.textField.main,
    fontWeight: 400,
    fontSize: theme.spacing(1.5),
    lineHeight: '16px',
    textAlign: 'center',
  },
  renewalIcon: {
    width: theme.spacing(1.75),
    height: theme.spacing(1.75),
    fontSize: theme.spacing(1.75),
    padding: theme.spacing(0, 1.125, 0, 0),
  },
  renewalOffIcon: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    verticalAlign: 'middle',
    padding: theme.spacing(0, 1.125, 0, 0),
  },
  contractRed: {
    color: theme.palette.error.dark,
  },
  name: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    gap: theme.spacing(1),
    color: theme.palette.select.light,
  },
  product: {
    color: theme.palette.textField.main,
    fontWeight: 400,
    fontSize: theme.spacing(1.5),
    lineHeight: '15px',
    textAlign: 'center',
  },
  buttonIcon: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    borderRadius: theme.spacing(0.5),
    padding: theme.spacing(0.5),
    border: `1px solid ${theme.palette.textField.main}`,
  },
  tableWrapper: {
    borderTop: `1px solid ${theme.palette.divider}`,
    marginTop: theme.spacing(-2),
  },
  dollarCss: {
    color: theme.palette.textField.main,
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '16px',
  },
  fontTotal: {
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '16px',
  },
  titleWrapper: {
    display: 'flex',
    gap: theme.spacing(1),
  },
  logoStatus: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  verticalDivider: {
    width: '1px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    alignSelf: 'stretch',
    borderRadius: '4px',
    background: theme.palette.dividerV2.main,
  },
  accordianWrapper: { display: 'flex', gap: '16px' },
  buyerIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: theme.spacing(3),
    height: theme.spacing(3),
    borderRadius: theme.spacing(0.375),
  },
  customIcon: {
    backgroundColor: theme.palette.backgroundV2.blue,
    alignItems: 'center',
    justifyContent: 'center',
    width: theme.spacing(3),
    height: theme.spacing(3),
    borderRadius: theme.spacing(0.375),
  },
  tableCell: {
    background: theme.palette.bg.main,
  },
  tableHeading: {
    fontSize: '12px',
    fontWeight: 400,
    color: theme.palette.labraText.description,
    lineHeight: '16px',
    fontStyle: 'normal',
    letterSpacing: '0px',
    width: '100%',
  },
}))
